// extracted by mini-css-extract-plugin
module.exports = {"userInput":"userForm_userInput__2Y2Mu","item":"userForm_item__2gMIy","icon":"userForm_icon__19U_H"};